import { FileAudio, FilePdf, Image, Plus } from '@phosphor-icons/react'
import React from 'react'

const ProjectSettings = ({
  new_project_content_path_for_pdf,
  new_project_content_path_for_images,
  new_project_content_path_for_audio,
  new_project_content_path,
}) => {
  return (
    <div className="dropdown dropdown-end">
      <label tabIndex="0" className="btn btn-outline btn-secondary">
        <div className="flex gap-2 items-center">
          <Plus weight="fill" color="teal" size={16}/>
          <span className="text-sm">Add</span>
        </div>
      </label>
      <ul tabIndex="0"
          className="dropdown-content z-[50] menu p-2 shadow bg-base-100 rounded-box w-52 m-2 border border-gray-200">
        <a href={new_project_content_path_for_pdf} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <FilePdf weight="fill" color="teal" size={16}/>
          <span>Upload PDF</span>
        </a>

        <a href={new_project_content_path_for_images} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <Image weight="fill" color="teal" size={16}/>
          <span>Upload Images</span>
        </a>

        <a href={new_project_content_path_for_audio} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <FileAudio weight="fill" color="teal" size={16}/>
          <span>Upload Audio</span>
        </a>

        <a href={new_project_content_path} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <Plus weight="fill" color="teal" size={16}/>
          <span>New Content</span>
        </a>
      </ul>
    </div>
  )
}

export default ProjectSettings